export default "__VITE_PUBLIC_ASSET__798197ca__"